import WixSDK from 'shared/utils/wix-sdk';

export default function subscribeOnActiveStatusChanged(itemId, isTrailer = false) {
  return `pubsub.${itemId}.${WixSDK.Utils.getUid()}.${isTrailer}`;
}



// WEBPACK FOOTER //
// ./src/dashboard/utils/get-catalog-callback-url.js